import React, { Component } from 'react';
// import SiSideNav from 'components/sidenav';
import TopHeader from '../distributorHome/header';
import SupportRemoteRequest from '../views/SupportRemoteAccess';



class SupportRemoteDistributor extends Component {

    constructor(props) {
        super(props);
    }

    openModal = () => {
        alert("modal opened");
    }

    render() {
        return (
            <div className="root">
                <TopHeader history={this.props.history} />
                {/* <SiSideNav history={this.props.history} selected="dashboard" /> */}
                <SupportRemoteRequest openModal={this.openModal} />
                {/* <SupportRemoteAccess/>
                <RemoteAccessform/> */}
            </div>
        )
    }
}

export default SupportRemoteDistributor;